<template>
  <div class="coverart coverart--stream">

    <animated-cover-art v-show="!showImage" />

    <div class="coverart__image-container" v-show="showImage">
      <div class="coverart__image">
        <img :src="showImage" />
      </div>
    </div>

  </div>
</template>

<script>
import AnimatedCoverArt from './AnimatedCoverArt.vue';

export default {
  name: "StreamCoverart",
  components: { AnimatedCoverArt },
  computed: {
    currentStream(){ return this.$store.state.player.stream; },
    showImage() {
      if(!this.currentStream) return false
      return this.currentStream.img
    }
  }
};
</script>

<style lang="scss">
  //Basis styling in podcast-coverart
  .coverart {
    &--stream {
      //Custom styling hier
    }
  }
</style>